import React, { FC, memo, useCallback, useContext } from "react";
import { FilterType } from "../types";
import { FiltersContext } from "../context/FiltersProvider";

type Props = {
  label: string;
  type: FilterType;
  icon?: string;
  hasDefaultValue: boolean;
};

const FilterBadge: FC<Props> = ({ type, label, icon, hasDefaultValue }) => {
  const { actions } = useContext(FiltersContext);
  const handleRemoved = useCallback(() => actions.onRemove(type), [
    type,
    actions.onRemove,
  ]);
  return (
    <div className="filter-badge">
      {icon && <span className={`icon ${icon}`} aria-hidden="true" />} {label}{" "}
      {!hasDefaultValue && (
        <span className="fa fa-times" onClick={handleRemoved} />
      )}
    </div>
  );
};

export default memo(FilterBadge);
